import { colorsList } from "../../data/colorsList";

export default function CalendarFrame({
  handleScroll,
  handlers,
  dm,
  writeEachDay,
  secondFlex,
}) {
  return (
    <div
      id="tableBox"
      onScroll={handleScroll}
      {...handlers}
      style={{
        position: "absolute",
        left: 0,
        top: 0,
        width: secondFlex.active && secondFlex.size === "h" ? "60%" : "100%",
        height: secondFlex.active && secondFlex.size === "v" ? "60%" : "100%",
        overflow: "auto",
      }}
    >
      <table
        id="calendarTable"
        className="table"
        style={{ width: "100%", height: "100%" }}
      >
        <thead>
          <tr className="titlecalendar">
            {dm.map((day, index) => (
              <th
                className="prevent-select"
                key={index}
                style={{ backgroundColor: colorsList.blue }}
              >
                {day}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{writeEachDay()}</tbody>
      </table>
    </div>
  );
}
